import { Observable } from 'rxjs';
import { of } from 'rxjs';

export const SUCCESS: Observable<void> = of(undefined);
